<template>
  <component
    :is="menuNavItem"
    v-if="isFavouritesEnabled"
    v-bind="componentProps"
    @click="trackNavigation"
  ></component>
</template>

<script setup lang="ts">
import {
  InteractionContainerName,
  InteractionEvent,
  InteractionGoal,
  trackEvent,
} from '@/helpers/GTM/GTMHelper';
import {
  HgMainNavItem,
  HgSideMenuNavItem,
  Icon,
  Is24MainNavItem,
  Is24SideMenuNavItem,
  type MenuItem,
} from '@smg-real-estate/domus';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const components = {
  HgMainNavItem,
  HgSideMenuNavItem,
  Is24MainNavItem,
  Is24SideMenuNavItem,
};

const props = defineProps<{
  menuItem: MenuItem;
  menuNavItem: 'Is24MainNavItem' | 'Is24SideMenuNavItem' | 'HgMainNavItem' | 'HgSideMenuNavItem';
}>();

const route = useRoute();
const store = useStore();
const baseUrl = import.meta.env.VUE_APP_BASE_URL;

const isFavouritesEnabled = computed(() => store.state.favourites.isFavouritesEnabled);

const isDotDisplayed = computed(
  () =>
    !!(
      store.getters.isFavouritesInitialized &&
      store.state.favourites.favouriteListingDescriptors.length > 0
    ),
);

const icon = computed(() => (isDotDisplayed.value ? Icon.HeartOutlineDot : Icon.HeartOutline));

const componentProps = computed(() => ({
  baseUrl,
  icon: icon.value,
  currentRoute: route,
}));

const trackNavigation = () => {
  trackEvent(InteractionEvent.HEADER_CLICK, {
    h_event_category_006: InteractionEvent.HEADER_CLICK,
    h_event_action_007: InteractionGoal.OPEN_FAVOURITES,
    h_event_label_008: InteractionContainerName.TAB_NAVIGATION,
    h_content_language_116: store.state.i18n.locale,
  });
};
</script>
